module.exports = __webpack_public_path__ + "img/icon-chevron-left.ef452bec.svg";